import { useState, useEffect } from "react";
import axiosInstance from "../../../api/axios";
import toast from "../../../shared/toast";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { newNotiTypeSchema } from "../../../validation/newNotiTypeSchema";
import Loading from "../../../shared/Loading";
import WaitLoading from "../../../shared/WaitLoading";

export default function NotificationTypeDetail() {
  const navigate = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [sendingLoading, setSendingLoading] = useState(false);

  const [formData, setFormData] = useState({
    type: "",
    image: null,
  });

  const [errors, setErrors] = useState({
    type: "",
    image: "",
  });

  const onChange = (e) => {
    if (e.target.name === "image") {
      setFormData((prevState) => ({
        ...prevState,
        image: e.target.files[0], // Kép fájl mentése
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const validateForm = () => {
    let formValid = true;
    let errors = {};

    if (!formData.type) {
      errors.type = "Az értesítés típusának megadása kötelező.";
      formValid = false;
    }

    setErrors(errors);
    return formValid;
  };

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(
        `/api-admin/notifications/get-notification-type/${params.notificationTypeId}`
      )
      .then((response) => {
        const clientData = response.data.result;

        // Itt frissítjük közvetlenül a formData állapotot
        setFormData((prevState) => ({
          ...prevState,
          type: clientData.type || "", // Megfelelően beállítjuk a típust
        }));
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast("error", error.response.data.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params.notificationTypeId]);

  const onSubmit = async (data) => {
    if (!validateForm()) return;
    setSendingLoading(true);
    const userData = {
      type: formData.type,
      image: formData.image,
    };

    const formDataToSend = new FormData();
    formDataToSend.append("type", userData.type);
    formDataToSend.append("image", userData.image);

    try {
      const response = await axiosInstance.post(
        `/api-admin/notifications/edit-notification-type/${params.notificationTypeId}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast("success", response.data.message);
      navigate("/notification-types");

      setFormData({
        type: "",
        image: null,
      });
    } catch (error) {
      console.error("Error posting data:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast("error", error.response.data.message);
      } else {
        toast("error", "Szerver hiba");
      }
    } finally {
      setSendingLoading(false);
    }
  };
  if (sendingLoading) {
    return <WaitLoading />;
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header card-no-border pb-3">
              <h3>Értesítés típus szerkesztése</h3>
            </div>

            {!loading ? (
              <div className="card-body">
                <div className="horizontal-wizard-wrapper">
                  <div className="row g-3">
                    <div className="col-12">
                      <div
                        className="tab-content dark-field"
                        id="horizontal-wizard-tabContent"
                      >
                        <div
                          className="tab-pane fade show active"
                          id="wizard-info"
                          role="tabpanel"
                          aria-labelledby="wizard-info-tab"
                        >
                          <form
                            className="row g-3 needs-validation basic-form"
                            onSubmit={onSubmit}
                          >
                            <div className="col-xl-4 col-sm-6">
                              <label
                                className="form-label"
                                htmlFor="notiTypeName"
                              >
                                Értesítés típusa
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="notiTypeName"
                                name="type"
                                type="text"
                                value={formData.type}
                                onChange={onChange}
                                placeholder="Értesítés típus megadása"
                              />
                              {errors.type && (
                                <p className="text-danger">{errors.type}</p>
                              )}
                            </div>

                            <div className="col-xl-4 col-sm-6">
                              <label className="form-label" htmlFor="image">
                                Kép feltöltése
                              </label>
                              <input
                                className="form-control"
                                type="file"
                                id="image"
                                name="image"
                                onChange={onChange} // Kép kiválasztásakor
                              />
                            </div>

                            <div className="col-12 text-end">
                              <button
                                className="btn btn-primary"
                                disabled={sendingLoading}
                              >
                                Mentés
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
